import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiesPolicy from './pages/CookiesPolicy';
import LegalNotice from './pages/LegalNotice';
import TerminosCondiciones from './pages/TerminosCondiciones';
import { HelmetProvider } from 'react-helmet-async';
import CookieConsent from './components/CookieConsent';
import ReactGA from 'react-ga4';


// Componente para manejar el seguimiento de páginas
function PageTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Comprobar si el usuario ha aceptado las cookies
    const consent = localStorage.getItem('cookieConsent');
    
    // Solo enviar datos de análisis si el usuario ha aceptado
    if (consent === 'accepted') {
      ReactGA.send({ 
        hitType: "pageview", 
        page: location.pathname + location.search 
      });
    }
  }, [location]);
  
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <PageTracker />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/proyectos" element={<Projects />} />
          <Route path="/servicios" element={<Services />} />
          <Route path="/quienes-somos" element={<About />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
          <Route path="/politica-cookies" element={<CookiesPolicy />} />
          <Route path="/aviso-legal" element={<LegalNotice />} />  
          <Route path="/terminos-y-condiciones" element={<TerminosCondiciones />} />        
        </Routes>
        <Footer />
        <CookieConsent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
// Comenta temporalmente el componente CookieConsent para ver si es la causa
// <CookieConsent />
